import { Delete } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NumpadPanel({
  enteredAmount, remainingBalance, handleNumpad, setInputStr,
  processCashPayment, getQuickCashAmounts, handleClose, tenders, styles,
  cardButtonsSlot
}) {
  const { amountDisplayFont, amountDisplaySize, amountDisplayWeight, amountDisplayBgColor, amountDisplayFontColor,
    numpadFont, numpadSize, numpadWeight, numpadBgColor, numpadFontColor,
    quickCashFont, quickCashSize, quickCashWeight, quickCashBgColor, quickCashFontColor,
    exactCashFont, exactCashSize, exactCashWeight, exactCashBgColor, exactCashFontColor } = styles;

  return (
    <>
      {/* Amount Display */}
      <div className="rounded-lg py-2 px-3 text-center" style={{ backgroundColor: amountDisplayBgColor }}>
        <div className="text-xs" style={{ color: amountDisplayFontColor, opacity: 0.7 }}>Enter amount for this payment</div>
        <div style={{
          fontFamily: `${amountDisplayFont}, sans-serif`,
          fontSize: `${amountDisplaySize}px`,
          fontWeight: amountDisplayWeight,
          color: amountDisplayFontColor
        }}>
          ${enteredAmount.toFixed(2)}
        </div>
      </div>

      {/* Numpad */}
      <div className="mt-2">
        <div className="grid grid-cols-3 gap-1">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((digit) => (
            <Button
              key={digit}
              variant="outline"
              className="h-[56px] rounded-lg"
              style={{
                fontFamily: `${numpadFont}, sans-serif`,
                fontSize: `${numpadSize}px`,
                fontWeight: numpadWeight,
                backgroundColor: numpadBgColor,
                color: numpadFontColor
              }}
              onClick={() => handleNumpad(digit)}
            >
              {digit}
            </Button>
          ))}
          <Button
            variant="outline"
            className="h-[56px] bg-yellow-50 text-yellow-700 hover:bg-yellow-100 rounded-lg"
            style={{
              fontFamily: `${numpadFont}, sans-serif`,
              fontSize: `${Math.round(parseInt(numpadSize) * 0.7)}px`,
              fontWeight: numpadWeight,
              backgroundColor: numpadBgColor,
              color: numpadFontColor
            }}
            onClick={() => setInputStr("")}
          >
            C
          </Button>
          <Button
            variant="outline"
            className="h-[56px] rounded-lg"
            style={{
              fontFamily: `${numpadFont}, sans-serif`,
              fontSize: `${numpadSize}px`,
              fontWeight: numpadWeight,
              backgroundColor: numpadBgColor,
              color: numpadFontColor
            }}
            onClick={() => handleNumpad(0)}
          >
            0
          </Button>
          <Button
            variant="outline"
            className="h-[56px] bg-red-50 text-red-600 hover:bg-red-100 rounded-lg"
            onClick={() => setInputStr(prev => prev.slice(0, -1))}
          >
            <Delete className="w-7 h-7" />
          </Button>
        </div>
      </div>

      {/* Quick Cash Keys */}
      <div className="mt-2 pt-2 border-t border-zinc-200">
        <div className="flex flex-wrap justify-center gap-1">
          {getQuickCashAmounts().filter(amt => amt !== null).map((amt) => (
            <Button
              key={amt}
              variant="outline"
              className="h-11 min-w-[60px] px-3 rounded-lg border hover:opacity-80"
              style={{
                fontFamily: `${quickCashFont}, sans-serif`,
                fontSize: `${quickCashSize}px`,
                fontWeight: quickCashWeight,
                backgroundColor: quickCashBgColor,
                color: quickCashFontColor,
                borderColor: quickCashBgColor
              }}
              onClick={() => processCashPayment(amt)}
            >
              ${amt}
            </Button>
          ))}
        </div>
      </div>

      {/* Card Buttons slot - rendered between quick cash and exact cash */}
      {cardButtonsSlot}

      {/* Exact Cash Button */}
      <div className="mt-2 pt-2 border-t border-zinc-200">
        <Button
          data-testid="exact-cash-btn"
          onClick={() => processCashPayment()}
          className="w-full h-12 rounded-xl shadow-lg hover:opacity-90"
          style={{ backgroundColor: exactCashBgColor, color: exactCashFontColor }}
        >
          <span style={{
            fontFamily: `${exactCashFont}, sans-serif`,
            fontSize: `${exactCashSize}px`,
            fontWeight: exactCashWeight
          }}>
            {enteredAmount > 0 ? `CASH $${enteredAmount.toFixed(2)}` : `EXACT CASH $${remainingBalance.toFixed(2)}`}
          </span>
        </Button>
      </div>

      {/* Cancel Button */}
      <Button
        data-testid="payment-cancel-btn"
        variant="outline"
        className="w-full h-10"
        onClick={handleClose}
      >
        Cancel
      </Button>
    </>
  );
}
